// コンバート ステータス
const ConvertStatus = [
  {
    value: 'sent',
    label: '掲載中',
  },
  {
    value: 'sending_reservation',
    label: '送信予約',
  },
  {
    value: 'expired',
    label: '期限切れ',
  },
  {
    value: 'deleting_reservation',
    label: '削除予約',
  },
  {
    value: 'deleted',
    label: '削除済み',
  },
  {
    value: 'due_today',
    label: '期限本日',
  },
  {
    value: 'not_posted',
    label: '未掲載',
  },
  {
    value: 'posting_not_possible',
    label: '掲載不可',
  },
  {
    value: 'panorama',
    label: 'パノラマ',
  },
  {
    value: 'panorama_enabled',
    label: 'パノラマ掲載',
  },
  {
    value: 'panorama_disabled',
    label: 'パノラマ未掲載',
  },
]

export default ConvertStatus
